import React, { useRef, useState } from "react";
import { updateCompany } from "../../../services/CompanyService";
import { toast } from "react-toastify";
import removerSpecialChars from "../../../util/StringUtils";
import ReactInputMask from "react-input-mask";
import ReactDatePicker from "react-datepicker";

const dayjs = require("dayjs");

export const AccordionDadosEmpresa = (props) => {
  const MAX_FILE_SIZE_BYTES = 200 * 1024;
  const ALLOWED_FILE_TYPES = ["image/png", "image/jpeg", "image/jpg"];
  const inputCnpj = useRef("");
  const inputCorporateName = useRef("");
  const inputFantasyName = useRef("");
  const inputAddress = useRef("");
  const inputEmail = useRef("");
  const inputWhatsAppNumber = useRef("");
  const iputCashCloseDay = useRef("");
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState();
  const [openHour, setOpenHour] = useState(
    new Date(props.companyInfo.openHour)
  );
  const [closeHour, setCloseHour] = useState(
    new Date(props.companyInfo.closeHour)
  );
  const [companyInfo, setCompanyInfo] = useState(props.companyInfo);
  const [remarketingEnabled, setRemarketingEnabled] = useState(
    props.companyInfo.remarketingEnabled
  );

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) {
      // Nenhum arquivo selecionado
      return;
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      // O arquivo excede o tamanho máximo permitido
      toast.warning(
        `O tamanho do arquivo deve ser no máximo ${MAX_FILE_SIZE_BYTES / 1024
        } KB.`
      );
      // Limpe o input de arquivo ou tome a ação apropriada
      event.target.value = null;
      return;
    }

    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      // O formato do arquivo não é suportado
      toast.warning(
        "Formato de arquivo não suportado. Por favor, selecione um arquivo PNG."
      );
      // Limpe o input de arquivo ou tome a ação apropriada
      event.target.value = null;
      return;
    }

    // Faça o que for necessário com o arquivo, se estiver dentro do tamanho e formato permitidos
    setLogo(file);

    if (event.target.files[0] && event.target.files[0].size > 256 * 1024) {
      // O arquivo excede o tamanho máximo permitido
      toast.warning(`O tamanho do arquivo deve ser no máximo 256 kb.`);
      // Limpe o input de arquivo ou tome a ação apropriada
      event.target.value = null;
    } else {
      // Faça o que for necessário com o arquivo, se estiver dentro do tamanho permitido
      setLogo(event.target.files[0]);
    }
  };

  function handleSubmit(e) {
    setLoading(true);
    e.preventDefault();

    const data = {
      documentNumber: removerSpecialChars(inputCnpj.current.value),
      corporateName: inputCorporateName.current.value,
      fantasyName: inputFantasyName.current.value,
      whatsAppNumber: removerSpecialChars(inputWhatsAppNumber.current.value),
      address: inputAddress.current.value,
      logo: logo ? logo : null,
      email: inputEmail.current.value,
      openHour: dayjs(openHour).format("HH:mm"),
      closeHour: dayjs(closeHour).format("HH:mm"),
      remarketingEnabled,
      cashCloseDay: parseInt(iputCashCloseDay.current.value),
    };
    const formData = new FormData();

    // Itera sobre as chaves do objeto data e append no FormData
    Object.keys(data).forEach((key) => {
      const value = data[key];

      // Adiciona ao FormData apenas se o valor não for nulo
      if (value !== null) {
        formData.append(key, value);
      }
    });

    updateCompany(companyInfo.id, formData)
      .then((response) => {
        props.loadCompanyInfo(false);
        toast.success(response);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data);
        setLoading(false);
      });
  }

  if (!companyInfo) return null;

  return (
    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
      {/* Cabeçalho do Card para dar contexto */}
      <div className="card-header bg-white border-bottom-0 pt-4 px-4">
        <h5 className="fw-bold text-dark mb-0">Dados da Empresa</h5>
        <p className="text-muted small">Gerencie as informações públicas e configurações do seu negócio</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="card-body p-4">
          {/* SEÇÃO 1: IDENTIFICAÇÃO (CARD LIGHT) */}
          <div className="bg-light p-3 rounded-4 border mb-4">
            <div className="d-flex align-items-center mb-3 text-primary">
              <i className="fas fa-id-card me-2"></i>
              <span className="fw-bold text-muted small text-uppercase">Identificação Principal</span>
            </div>
            <div className="row g-3">
              <div className="col-lg-6">
                <label className="form-label small fw-bold text-dark">Nome da Empresa</label>
                <input
                  defaultValue={companyInfo.fantasyName}
                  ref={inputFantasyName}
                  className="form-control form-control-lg fs-6 rounded-3 border-2"
                  placeholder="Ex: Alcon Auto Estética"
                  required
                />
              </div>

              <div className="col-lg-6">
                <label className="form-label small fw-bold text-dark">CPF / CNPJ</label>
                <input
                  id="cnpj"
                  defaultValue={companyInfo.documentNumber}
                  ref={inputCnpj}
                  inputMode="numeric"
                  className="form-control form-control-lg fs-6 rounded-3 border-2"
                  placeholder="Apenas números"
                  required
                />
              </div>
              <div className="col-lg-6">
                <label className="form-label small fw-bold text-dark">Logo da Empresa</label>
                <div className="d-flex align-items-center gap-3">
                  <input
                    onChange={handleFileChange}
                    type="file"
                    className="form-control form-control-lg fs-6 rounded-3 border-2"
                  />
                  {companyInfo.logo && (
                    <div className="border rounded-3 p-1 bg-white shadow-sm">
                      <img
                        width={45}
                        height={45}
                        className="rounded-2 object-fit-contain"
                        src={"data:image/png;base64," + companyInfo.logo}
                        alt="Logo preview"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* SEÇÃO 2: CONTATO E LOCALIZAÇÃO */}
          <div className="bg-white p-3 rounded-4 border mb-4 shadow-sm">
            <div className="d-flex align-items-center mb-3 text-primary">
              <i className="fas fa-map-marker-alt me-2"></i>
              <span className="fw-bold text-muted small text-uppercase">Contato e Endereço da Empresa</span>
            </div>
            <div className="row g-3">

              <div className="col-lg-6">
                <label className="form-label small fw-bold text-dark">E-mail</label>
                <input
                  defaultValue={companyInfo.email}
                  ref={inputEmail}
                  type="email"
                  className="form-control rounded-3 border-2"
                  placeholder="exemplo@alcon.com"
                />
              </div>
              <div className="col-lg-6">
                <label className="form-label small fw-bold text-dark">WhatsApp / Telefone</label>
                <ReactInputMask
                  defaultValue={companyInfo.whatsAppNumber}
                  ref={inputWhatsAppNumber}
                  className="form-control rounded-3 border-2 fw-bold text-primary"
                  mask="(99) 99999-9999"
                  required
                />
              </div>
              <div className="col-lg-12">
                <label className="form-label small fw-bold text-dark">Endereço Completo</label>
                <input
                  defaultValue={companyInfo.address}
                  ref={inputAddress}
                  className="form-control rounded-3 border-2"
                  placeholder="Rua, número, bairro e cidade"
                  required
                />
              </div>
            </div>
          </div>

          {/* SEÇÃO 3: OPERAÇÃO E FECHAMENTO */}
          <div className="bg-light p-3 rounded-4 border">
            <div className="d-flex align-items-center mb-3 text-primary">
              <i className="fas fa-cog me-2"></i>
              <span className="fw-bold text-muted small text-uppercase">Configurações de Operação</span>
            </div>
            <div className="row g-4">
              <div className="col-lg-6 border-end border-sm-none">
                <label className="form-label small fw-bold text-dark d-block">Horário de Funcionamento</label>
                <div className="d-flex gap-2">
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">Abre às</small>
                    <ReactDatePicker
                      id="openAt"
                      className="form-control rounded-3 border-2 fw-bold text-center"
                      dateFormat="HH:mm"
                      timeCaption="Abre às"
                      showTimeSelect
                      showTimeSelectOnly
                      locale="pt-BR"
                      selected={openHour}
                      onChange={(date) => setOpenHour(date)}
                      required
                    />
                  </div>
                  <div className="flex-grow-1">
                    <small className="text-muted d-block mb-1">Fecha às</small>
                    <ReactDatePicker
                      id="closeAt"
                      className="form-control rounded-3 border-2 fw-bold text-center"
                      dateFormat="HH:mm"
                      showTimeSelect
                      showTimeSelectOnly
                      timeCaption="Fecha às"
                      locale="pt-BR"
                      selected={closeHour}
                      onChange={(date) => setCloseHour(date)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-3 text-center border-end border-sm-none">
                <label className="form-label small fw-bold text-dark mb-1">Dia Fechamento</label>
                <div className="d-flex justify-content-center mt-2">
                  <input
                    style={{ width: "4rem", fontSize: '1.2rem' }}
                    ref={iputCashCloseDay}
                    className="form-control border-2 text-center fw-bold rounded-3"
                    type="number"
                    defaultValue={companyInfo.cashCloseDay}
                    min={1}
                    max={30}
                    required
                  />
                </div>
                <small className="text-muted mt-2 d-block px-2" style={{ fontSize: '0.65rem' }}>Dia do balanço mensal</small>
              </div>

              <div className="col-lg-3 text-center d-flex flex-column align-items-center justify-content-center">
                <label className="form-label small fw-bold text-dark mb-2">Lembrete Automático</label>
                <div className="form-check form-switch mt-1">
                  <input
                    id="switchRemarketing"
                    className="form-check-input cursor-pointer shadow-none"
                    style={{ width: '2.5rem', height: '1.25rem' }}
                    type="checkbox"
                    checked={remarketingEnabled}
                    onChange={() => setRemarketingEnabled(!remarketingEnabled)}
                  />
                </div>
                <small className={`fw-bold mt-2 ${remarketingEnabled ? 'text-success' : 'text-danger'}`} style={{ fontSize: '0.75rem' }}>
                  {remarketingEnabled ? "Ativado (15 dias)" : "Desativado"}
                </small>
              </div>
            </div>
          </div>
        </div>

        <div className="card-footer bg-white border-top-0 p-4 pt-2">
          {!loading ? (
            <div className="d-flex flex-column flex-sm-row w-100 gap-2 justify-content-sm-end">

              {/* Botão Salvar: No Desktop ele volta ao tamanho normal, no Mobile cresce */}
              <button
                type="submit"
                className="btn btn-primary btn-lg fw-bold rounded-3 shadow-sm order-0 px-s"
                style={{ minWidth: '200px' }} // Garante que não fique pequeno demais no desktop
              >
                <i className="fas fa-save me-2"></i>
                Salvar Configurações
              </button>

              {/* Se quiser adicionar um botão de cancelar/voltar no futuro, ele entrará aqui */}

            </div>
          ) : (
            <div className="w-100 text-center py-2">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default AccordionDadosEmpresa;
